import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import { FiShoppingBag, FiFileText, FiCreditCard, FiCheck } from "react-icons/fi";
import { Container, StepCircle, Steps, StyledLinkLogo } from './styles';
import { Creators as CouponActions } from "../../store/ducks/coupon";
import { logoCabecalho, erroLogo } from "../../util/logoLoja";

const BuySteps = ({ step, history }) => {
  const { data } = useSelector(state => state.store);
  const { data: identidade } = useSelector(state => state.identidadeVisual);
  const dispatch = useDispatch();

  const clearCoupon = () => {
    dispatch(CouponActions.clearCoupon());
  }

  const handleNextPage = (url) => {
    if (step <= 4){
      clearCoupon();
      history.push(url);
    }
  };

  return (
    <>
      <Container>
        <div className='container-logo-steps'>
          <ToastContainer autoClose={2500} />
          {data && data.empresa && data.empresa.url && (
            <StyledLinkLogo to="/">
              <img
                src={logoCabecalho(identidade, data.empresa)}
                title={data?.empresa?.nome}
                alt={`${data?.empresa?.nome}`}
                onError={erroLogo}
              />
            </StyledLinkLogo>

          )}
          <Steps>
            <div className='line' />
            <div className='lineEvo' style={{ "width": step > 1 && step < 3 ? ((100 * (step - 1)) + 62) + "px" : (step === 3 || step === 4 ? "221px" : "62px") }} />
            <StepCircle
              className={step > 0 ? 'active' : ''}
              onClick={step !== 4 && step > 0 ? () => handleNextPage("/carrinho") : undefined}
              title={"Cesta de Compras"}
            >
              <FiShoppingBag />
            </StepCircle>
            <StepCircle
              className={step > 1 ? 'active' : ''}
              onClick={step !== 4 && step > 1 ? () => handleNextPage("/checkout/revisao") : undefined}
              title={"Revisão do pedido"}
            >
              <FiFileText />
            </StepCircle>
            {
              step === 4 ? (
                <StepCircle className='active' title={"Pedido finalizado"}>
                  <FiCheck />
                </StepCircle>
              ) : (
                <StepCircle
                  className={step > 2 ? 'active' : ''}
                  onClick={step !== 4 && step > 2 ? () => handleNextPage("/checkout/pagamento") : undefined}
                  title={"Forma de Pagamento"}
                >
                  <FiCreditCard />
                </StepCircle>
              )
            }
          </Steps>
        </div>
      </Container>
    </>
  );
};

export default BuySteps;
